import {
  LOAD_OPEN_FOR_WORK_SUCCESS,
  UPDATE_OPEN_FOR_WORK,
  UPDATE_OPEN_FOR_WORK_SUCCESS,
  UPDATE_OPEN_FOR_WORK_FAILED,
  CLOSE_OPEN_FOR_WORK_SNACKBAR,
  LOCATION_CHANGE,
  GET_AREA_OF_EXPERTISE_SUCCESS,
  GET_AREA_OF_WORK_SUCCESS
} from '../constants'

const initialState = {
  showSnackbar: false,
  showFailSnackbar: false,
  clearState: false,
  workId: '',
  isEdit: false,
  applicationData: [],
  areaExpertiseList: [],
  areaOfWorkList: []
}

const openforworkReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_AREA_OF_EXPERTISE_SUCCESS:
      return {
        ...state,
        areaExpertiseList: [...action.data]
      }

    case GET_AREA_OF_WORK_SUCCESS:
      return {
        ...state,
        areaOfWorkList: [...action.data]
      }

    case LOAD_OPEN_FOR_WORK_SUCCESS:
      let workId = action.result.Id
      return Object.assign(
        {},
        { ...state },
        {
          applicationData: action.result,
          isEdit: true,
          workId: workId,
          clearState: false
        }
      )

    case UPDATE_OPEN_FOR_WORK:
      return Object.assign(
        {},
        { ...state },
        {
          clearState: true
        }
      )

    case UPDATE_OPEN_FOR_WORK_SUCCESS:
      return Object.assign(
        {},
        { ...state },
        {
          showSnackbar: true,
          clearState: false
          // isEdit: false
        }
      )

    case UPDATE_OPEN_FOR_WORK_FAILED:
      return Object.assign(
        {},
        { ...state },
        {
          showFailSnackbar: true,
          clearState: false
        }
      )

    case CLOSE_OPEN_FOR_WORK_SNACKBAR:
      return Object.assign(
        {},
        { ...state },
        {
          showSnackbar: false,
          showFailSnackbar: false
        }
      )

    case LOCATION_CHANGE:
      return Object.assign(
        {},
        { ...state },
        {
          showSnackbar: false,
          showFailSnackbar: false,
          clearState: false,
          isEdit: false
        }
      )

    default:
      return state
  }
}

export default openforworkReducer
